import './es.number.constructor-f2ac18e9.js';
import { d as anObject, m as globalThis_1, f as fails, y as shared, b as functionUncurryThis, a as functionCall, o as internalState } from './index-f674799c.js';
import './es.string.trim-1d1c26df.js';
import { toRefs, computed, watch, resolveComponent, resolveDirective, openBlock, createElementBlock, normalizeClass, Fragment, withDirectives, createElementVNode, renderSlot, createCommentVNode, createVNode, vShow, createBlock, withCtx, vModelDynamic, toDisplayString } from 'vue';
import { useField } from 'vee-validate';
import Password from 'primevue/password';
import { t as toString_1, _ as _export } from './to-string-6d234645.js';
import { a as objectCreate } from './object-create-ee21b296.js';
import { u as useToggler } from './useToggler-e9ff86c0.js';
import moment from 'moment';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = globalThis_1.RegExp;

var UNSUPPORTED_Y$1 = fails(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y$1 || fails(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$1 || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$1
};

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = globalThis_1.RegExp;

var regexpUnsupportedDotAll = fails(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = globalThis_1.RegExp;

var regexpUnsupportedNcg = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */







var getInternalState = internalState.get;



var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = functionUncurryThis(''.charAt);
var indexOf = functionUncurryThis(''.indexOf);
var replace = functionUncurryThis(''.replace);
var stringSlice = functionUncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  functionCall(nativeExec, re1, 'a');
  functionCall(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = regexpStickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || regexpUnsupportedDotAll || regexpUnsupportedNcg;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString_1(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = functionCall(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = functionCall(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = functionCall(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      functionCall(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = objectCreate(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec = patchedExec;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
_export({ target: 'RegExp', proto: true, forced: /./.exec !== regexpExec }, {
  exec: regexpExec
});

/**
 * Used to validate input
 * @returns methods for validation
 */
function useInputValidate () {
  var EMAIL_REGEX = /^[\S._%+-]+@[\S.-]+\.[A-Za-z]{2,}$/;
  var URL_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)/i;
  /**
   * whether the given string is a valid email address
   * @param email email address in string
   * @returns true|false
   */

  function isValidEmail(email) {
    return EMAIL_REGEX.test(email.trim().toLowerCase());
  }
  /**
   * whether the given string is a valid url.
   * @param url url in string
   * @returns true|false
   */


  function isValidURL(url) {
    return URL_REGEX.test(url.trim());
  }

  return {
    isValidEmail: isValidEmail,
    isValidURL: isValidURL
  };
}

library.add(faQuestionCircle);
var script = {
  name: 'form-control-input',
  props: {
    name: {
      required: true,
      type: String
    },
    code: {
      required: false,
      type: String,
      default: ''
    },
    label: {
      required: false,
      type: String,
      default: ''
    },
    required: {
      required: false,
      type: Boolean,
      default: false
    },
    placeholder: {
      required: false,
      type: String,
      default: ''
    },
    type: {
      required: false,
      type: String,
      default: 'text'
    },
    cachevalue: {
      required: false,
      type: String,
      default: ''
    },
    defaultvalue: {
      required: false,
      type: String,
      default: ''
    },
    shouldcache: {
      required: false,
      type: Boolean,
      default: false
    },
    additionalLabelClasses: {
      required: false,
      type: String,
      default: ''
    },
    error: {
      required: false,
      type: String,
      default: ''
    },
    serverError: {
      required: false,
      type: String,
      default: ''
    },
    help: {
      required: false,
      type: String,
      default: ''
    },
    hidden: {
      required: false,
      type: Boolean,
      default: false
    },
    pattern: {
      required: false,
      type: String,
      default: undefined
    },
    repeatFromAnotherInputId: {
      required: false,
      type: String,
      default: ''
    },
    prefixId: {
      required: false,
      type: String,
      default: 'wdw-form-attr'
    },
    visibleIfResult: {
      required: false,
      type: Boolean,
      default: true
    },
    minLength: {
      required: false,
      type: Number
    },
    maxLength: {
      required: false,
      type: Number
    },
    readonly: {
      required: false,
      type: Boolean
    },
    min: {
      required: false,
      type: Number
    },
    max: {
      required: false,
      type: Number
    },
    isPublic: {
      type: Boolean,
      default: true
    },
    reset: {
      type: Boolean,
      required: false,
      default: false
    },
    feedback: {
      type: Boolean,
      required: false,
      default: false
    },
    feedbackHeader: {
      type: String,
      required: false
    },
    feedbackFooter: {
      type: String,
      required: false
    },
    strongRegex: {
      type: String,
      required: false
    },
    mediumRegex: {
      type: String,
      required: false
    }
  },
  components: {
    Password: Password
  },
  emits: ['validate'],
  setup: function setup(props, context) {
    var _toRefs = toRefs(props),
        name = _toRefs.name,
        code = _toRefs.code,
        label = _toRefs.label,
        type = _toRefs.type,
        min = _toRefs.min,
        max = _toRefs.max,
        required = _toRefs.required,
        defaultvalue = _toRefs.defaultvalue,
        error = _toRefs.error,
        serverError = _toRefs.serverError,
        additionalLabelClasses = _toRefs.additionalLabelClasses,
        shouldcache = _toRefs.shouldcache,
        repeatFromAnotherInputId = _toRefs.repeatFromAnotherInputId,
        prefixId = _toRefs.prefixId,
        isPublic = _toRefs.isPublic,
        reset = _toRefs.reset;

    var _useInputValidate = useInputValidate(),
        isValidEmail = _useInputValidate.isValidEmail,
        isValidURL = _useInputValidate.isValidURL;

    var _useToggler = useToggler(),
        shouldShowHelp = _useToggler.toggleValue,
        toggleHelpText = _useToggler.toggle; //+---------------------+
    //|    Other functions  |
    //+---------------------+


    function validate(value) {
      var finalvalue = value;

      if (typeof value == 'string') {
        finalvalue = value.trim();
      }

      var returnValue = {
        value: value,
        valueHuman: value,
        validated: true,
        name: name.value,
        code: code.value,
        type: type.value
      };

      if (required.value || finalvalue !== '' && finalvalue !== defaultvalue.value) {
        var inptype = type.value;

        if (inptype == 'number' && typeof finalvalue == 'number') {
          var validated = true;

          if (min.value && min.value > finalvalue) {
            validated = false;
          }

          if (max.value && max.value < finalvalue) {
            validated = false;
          }

          if (isNaN(finalvalue)) validated = false;
          returnValue.validated = validated;
        } else if (inptype == 'email' && typeof finalvalue == 'string') {
          returnValue.validated = isValidEmail(finalvalue);
        } else if (inptype == 'link' && typeof finalvalue == 'string') {
          returnValue.validated = isValidURL(finalvalue);
        } else if (inptype == 'datetime-local') {
          returnValue.validated = moment(finalvalue).isSameOrAfter(moment());
        } else if (repeatFromAnotherInputId.value !== '') {
          var anotherInp = document.getElementById(repeatFromAnotherInputId.value);

          if (anotherInp) {
            returnValue.validated = anotherInp.value !== '' && finalvalue !== '' && anotherInp.value == finalvalue;
          } else {
            returnValue.validated = true;
          }
        } else {
          returnValue.validated = finalvalue !== '';
        }
      }

      if (shouldcache.value) {
        localStorage.setItem(name.value, String(returnValue.value));
      } // Emit event


      context.emit('validate', returnValue);
      return returnValue.validated ? true : error.value;
    }

    var _useField = useField(name, validate, {
      initialValue: defaultvalue.value
    }),
        errorMessage = _useField.errorMessage,
        value = _useField.value,
        triggerValidation = _useField.validate;

    function handleBlur() {
      triggerValidation();
    }

    function resetInput() {
      value.value = defaultvalue.value;
      validate(value.value);
    }

    function setValue(string) {
      value.value = string;
      validate(string);
    }

    context.expose({
      setValue: setValue,
      name: name,
      value: value,
      type: type
    }); //+---------------------+
    //|    computed()       |
    //+---------------------+

    var hasError = computed(function () {
      return errorMessage.value != undefined;
    });
    var hasServerError = computed(function () {
      return serverError.value != undefined && serverError.value !== '';
    });
    var wrapperClassName = computed(function () {
      return {
        'form-group': true,
        'has-error': hasError.value || hasServerError.value,
        'input-highlight': defaultvalue.value !== value.value && reset.value // Highlight element if a defaultvalue is present

      };
    });
    var labelClassName = computed(function () {
      return additionalLabelClasses.value + ' ' + (hasError.value || hasServerError.value ? 'text-danger' : '');
    });
    var inputClassName = computed(function () {
      // refactor to string to be able to provide class-names to Password-component from primevue (expects string)
      var classes = 'form-control input-element';

      if (hasError.value || hasServerError.value) {
        classes += ' is-invalid';
      }

      return classes;
    });
    var labelText = computed(function () {
      return label.value + (required.value ? '*' : '') + (isPublic.value ? '' : ' - <span class="text-muted">Diese Daten werden nicht veröffentlicht.</span>');
    });
    var idInput = computed(function () {
      return prefixId.value + '-text-' + name.value;
    });
    var idErrorText = computed(function () {
      return prefixId.value + '-text-' + name.value + '-error';
    });
    var inputType = computed(function () {
      var typeVal = type.value;

      if (typeVal == 'number') {
        return 'number';
      } else if (typeVal == 'email') {
        return 'email';
      } else if (typeVal == 'link') {
        return 'url';
      } else if (typeVal == 'password') {
        return 'password';
      } else if (typeVal == 'datetime-local') {
        return 'datetime-local';
      }

      return 'text';
    });
    var showResetButton = computed(function () {
      return defaultvalue.value !== value.value && reset.value;
    }); //+---------------------+
    //|  Lifecycle Hooks    |
    //+---------------------+

    watch(defaultvalue, function (nV) {
      value.value = nV;
    }); //+---------------------+
    //|    return data      |
    //+---------------------+

    return {
      // Computed
      hasError: hasError,
      hasServerError: hasServerError,
      wrapperClassName: wrapperClassName,
      labelClassName: labelClassName,
      inputClassName: inputClassName,
      idInput: idInput,
      idErrorText: idErrorText,
      inputType: inputType,
      labelText: labelText,
      showResetButton: showResetButton,
      // Methods
      handleBlur: handleBlur,
      toggleHelpText: toggleHelpText,
      resetInput: resetInput,
      // Variables
      shouldShowHelp: shouldShowHelp,
      errorMessage: errorMessage,
      value: value
    };
  }
};

var _hoisted_1 = ["for", "aria-label"];
var _hoisted_2 = {
  class: "wdw-dynamic-label-addition"
};
var _hoisted_3 = {
  class: "alert alert-info alert-dismissible mb-2 form-info-message",
  role: "alert"
};
var _hoisted_4 = ["innerHTML"];
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = ["id", "data-wdw-code", "type", "data-vv-as", "name", "required", "placeholder", "pattern", "aria-invalid", "aria-describedby", "hidden", "minlength", "maxlength", "readonly", "min", "max"];
var _hoisted_7 = ["id"];
var _hoisted_8 = ["id"];
var _hoisted_9 = {
  key: 0,
  class: "text-danger form-error-message"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  var _component_Password = resolveComponent("Password");

  var _directive_dompurify_html = resolveDirective("dompurify-html");

  return $props.visibleIfResult ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass($setup.wrapperClassName),
    id: "wdw-library-form-control-input"
  }, [!$props.hidden ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [withDirectives(createElementVNode("label", {
    class: normalizeClass([$setup.labelClassName]),
    for: $setup.idInput,
    "aria-label": $props.label
  }, null, 10, _hoisted_1), [[_directive_dompurify_html, $setup.labelText]]), createElementVNode("span", _hoisted_2, [renderSlot(_ctx.$slots, "dynamicLabel")]), $setup.showResetButton ? (openBlock(), createElementBlock("span", {
    key: 0,
    class: "btn btn-danger delete-filter",
    title: "Eingabe verwerfen",
    onClick: _cache[0] || (_cache[0] = function () {
      return $setup.resetInput && $setup.resetInput.apply($setup, arguments);
    })
  }, " ✕ ")) : createCommentVNode("", true), $props.help ? (openBlock(), createElementBlock("span", {
    key: 1,
    class: "help-trigger",
    title: "Hilfe anzeigen",
    onClick: _cache[1] || (_cache[1] = function () {
      return $setup.toggleHelpText && $setup.toggleHelpText.apply($setup, arguments);
    })
  }, [createVNode(_component_font_awesome_icon, {
    icon: "question-circle",
    size: "lg"
  })])) : createCommentVNode("", true), withDirectives(createElementVNode("div", _hoisted_3, [withDirectives(createElementVNode("span", null, null, 512), [[_directive_dompurify_html, $props.help]]), createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "aria-label": "Close",
    onClick: _cache[2] || (_cache[2] = function () {
      return $setup.toggleHelpText && $setup.toggleHelpText.apply($setup, arguments);
    })
  })], 512), [[vShow, $setup.shouldShowHelp]])], 64)) : createCommentVNode("", true), $setup.inputType == "password" ? (openBlock(), createBlock(_component_Password, {
    key: 1,
    id: $setup.idInput,
    class: "d-block",
    inputClass: $setup.inputClassName,
    modelValue: $setup.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $setup.value = $event;
    }),
    feedback: $props.feedback,
    toggleMask: true,
    "aria-invalid": $setup.hasError || $setup.hasServerError,
    "data-vv-as": $setup.labelText,
    name: $props.name,
    required: $props.required,
    placeholder: $props.placeholder,
    pattern: $props.pattern,
    ref: "input",
    "data-wdw-code": $props.code,
    inputProps: $props.feedback ? {
      autocomplete: 'new-password'
    } : undefined,
    promptLabel: "Wähle ein Passwort",
    weakLabel: "Nicht ausreichend",
    strongLabel: "Stark",
    strongRegex: $props.strongRegex,
    mediumRegex: $props.mediumRegex
  }, {
    header: withCtx(function () {
      return [createElementVNode("span", {
        innerHTML: $props.feedbackHeader
      }, null, 8, _hoisted_4)];
    }),
    footer: withCtx(function () {
      return [createElementVNode("span", {
        innerHTML: $props.feedbackFooter
      }, null, 8, _hoisted_5)];
    }),
    _: 1
  }, 8, ["id", "inputClass", "modelValue", "feedback", "aria-invalid", "data-vv-as", "name", "required", "placeholder", "pattern", "data-wdw-code", "inputProps", "strongRegex", "mediumRegex"])) : withDirectives((openBlock(), createElementBlock("input", {
    key: 2,
    id: $setup.idInput,
    "data-wdw-code": $props.code,
    ref: "input",
    type: $setup.inputType,
    "data-vv-as": $setup.labelText,
    name: $props.name,
    required: $props.required,
    placeholder: $props.placeholder,
    pattern: $props.pattern,
    class: normalizeClass($setup.inputClassName),
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $setup.value = $event;
    }),
    tabindex: "0",
    "aria-invalid": $setup.hasError || $setup.hasServerError,
    "aria-describedby": $setup.idErrorText,
    hidden: $props.hidden,
    minlength: $props.minLength,
    maxlength: $props.maxLength,
    readonly: $props.readonly,
    min: $props.min,
    max: $props.max,
    onBlur: _cache[5] || (_cache[5] = function () {
      return $setup.handleBlur && $setup.handleBlur.apply($setup, arguments);
    })
  }, null, 42, _hoisted_6)), [[vModelDynamic, $setup.value]]), !$props.hidden ? (openBlock(), createElementBlock(Fragment, {
    key: 3
  }, [withDirectives(createElementVNode("span", {
    id: $setup.idErrorText,
    class: "text-danger form-error-message",
    "aria-atomic": "true"
  }, toDisplayString($props.error), 9, _hoisted_7), [[vShow, $setup.hasError]]), withDirectives(createElementVNode("span", {
    id: $setup.idErrorText,
    class: "text-danger form-error-message",
    "aria-atomic": "true"
  }, toDisplayString($props.serverError), 9, _hoisted_8), [[vShow, $setup.hasServerError]]), $setup.hasError && $setup.inputType == "password" ? (openBlock(), createElementBlock("span", _hoisted_9, " Bitte geben Sie ein Passwort ein ")) : createCommentVNode("", true)], 64)) : createCommentVNode("", true)], 2)) : createCommentVNode("", true);
}

script.render = render;
script.__scopeId = "data-v-54cf5f34";

export { regexpStickyHelpers as a, regexpFlags as b, regexpExec as r, script as s };
